import React, { useState, useEffect } from "react";
import axios from "axios";
import fog_headd from "../../Assets/Images/fog_headd.png";
// import CardImg from "../../Assets/Images/3.jpg.png";
import aboutBanner from "../../Assets/Images/all.png";
import Card from "../../Components/Card/Card.js";
import TestimonialCard from "../../Components/TestimonialCard/TestimonialCard.js";
import bread from "../../Assets/Images/bread.png";
import { FiTruck } from "react-icons/fi";
import { MdOutlineSupportAgent, MdPayments } from "react-icons/md";
import { BiTimer } from "react-icons/bi";
// import { ProductData } from "../../Data/productsData.js";//
import "./Home.scss";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllProducts,
} from "../../Redux/slices/productSlice";
import { getUserDetail } from "../../Redux/slices/user";
import MinLoader from "../../Components/Loader/MinLoader";

//SwiperSLider
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { setNavbar } from "../../Redux/slices/appConfigSlice";
SwiperCore.use([Autoplay, Navigation, Pagination]);

const breakpoints = {
  333: {
    slidesPerView: 1, // 1 slide per view for screens up to 320px wide
  },

  420: {
    slidesPerView: 1.2, // 1 slide per view for screens up to 320px wide
  },
  480: {
    slidesPerView: 2, // 2 slides per view for screens up to 480px wide
  },
  768: {
    slidesPerView: 3, // 3 slides per view for screens up to 768px wide
  },
  1024: {
    slidesPerView: 5, // 4 slides per view for screens up to 1024px wide
  },
};
const testBreakpoints = {
  320: {
    slidesPerView: 1, // 1 slide per view for screens up to 320px wide
  },
  480: {
    slidesPerView: 2, // 2 slides per view for screens up to 480px wide
  },
  768: {
    slidesPerView: 3, // 3 slides per view for screens up to 768px wide
  },
  1024: {
    slidesPerView: 5, // 4 slides per view for screens up to 1024px wide
  },
};

function Home() {
  const dispatch = useDispatch();
  const { products, categories, carts } = useSelector(
    (state) => state.products
  );
  // const { isLoading } = useSelector((state) => state.app);
  const [isLoading ,setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(getAllProducts());
    dispatch(getAllCategories());
    dispatch(getUserDetail());
    dispatch(setNavbar(true));
  }, [dispatch]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const isInCart = (productId) => {
    console.log(typeof productId);
    return carts?.some((item) => item._id === productId);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    axios
      .post("/send-email", formData)
      .then(() => {
        alert("Your message has been sent!");
        setFormData({
          name: "",
          email: "",
          message: "",
        });
      })
      .catch(() => {
        alert("Succesfully sent your message!!");
      });
  };

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 640);
    };

    handleResize(); 
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize); 
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  return (
    <div className="Home">
      {/* {---------------------HERO SECTION START----------------------------} */}

      <div className="banner">
        <div className=" hero__container">
          {/* <img src={webHeader} alt="HERO__IMG" /> */}
          <img src={fog_headd} alt="HERO__IMG" />
        </div>
      </div>

      {/* {---------------------HERO SECTION END----------------------------} */}

      {/* {---------------------POPULAR-CATEGORY  SECTION START----------------------------} */}

       <div className="categories">
      <div className="categories__main container">
        <div className="cat-head">
          <h2>Shop By</h2>
          <h1>Categories</h1>
        </div>
        <div className="cat-wrapper">
          {isLoading ? (
            <MinLoader />
          ) : isMobileView ? (
            categories.map((category) => (
              <Link key={category.name} to={`/shop/${category.name}`}>
                <img
                  src={category?.image.url}
                  alt="category"
                  style={{
                    minWidth: 100,
                    minHeight: 100,
                    maxWidth: 230,
                    maxHeight: 230,
                  }}
                />
              </Link>
            ))
          ) : (
            <Swiper
            className="swiper"
            spaceBetween={40}
            slidesPerView={5}
            navigation={true} // Add navigation prop to show prev and next buttons
            onSwiper={(swiper) => console.log(swiper)}
            onSlideChange={() => console.log("slide change")}
            breakpoints={breakpoints}
            autoplay={{ delay: 600000, disableOnInteraction: false }} // Enable autoplay with 2-second delay between slides
            >
              {categories.map((category) => (
                <SwiperSlide key={category.name}>
                  <Link to={`/shop/${category.name}`}>
                    <img
                      src={category?.image.url}
                      alt="category"
                      style={{
                        minWidth: 20,
                        minHeight: 20,
                        maxWidth: 230,
                        maxHeight: 230,
                      }}
                    />
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>

        <div className="cat-btn">
          <Link to="/shop" className="btn bl-btn">
            Go to Shop
          </Link>
        </div>
      </div>
    </div>

      {/* {---------------------CARD SECTION START----------------------------} */}
      <article className="products">
        <div className="container products__container">
          <div className="popular_product">
            <div className="p-head-wrapper">
              <h1 className="p-head">
                Our <span className="g-text">Newly Added</span>
              </h1>
              <Link to="/shop" className="view">View all</Link>
            </div>
            {isLoading ? (
              <div
                style={{
                  width: "90vw",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <MinLoader />
              </div>
            ) : (
              <Swiper
                className="swiper"
                spaceBetween={20}
                // slidesPerView={5}
                navigation // Enable navigation
                autoplay={{ delay: 2000, disableOnInteraction: false }}
                breakpoints={breakpoints}
              >
                {products?.map((item, index) => (
                  <SwiperSlide>
                    <Card
                      isOnCart={isInCart(item._id) ? true : false}
                      key={item.name + index}
                      imgUrl={item?.images[0]?.url}
                      name={item.name}
                      price={item.weightPrice[0]?.price}
                      weight={item.weightPrice[0]?.weight}
                      salePrice={item.weightPrice[0]?.price}
                      category={item.category}
                      id={item._id}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>

          <div className="popular_product">
            <div className="p-head-wrapper">
              <h1 className="p-head">
                Our <span className="g-text">Best selling</span>
              </h1>
              <Link to="/shop" className="view">View all</Link>
            </div>
            <div className="pp-wrapper">
              <div className="pp-row">
                {isLoading ? (
                  <div
                    style={{
                      width: "90vw",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <MinLoader />
                  </div>
                ) : (
                  <Swiper
                    // className="swipers"
                    spaceBetween={20}
                    // slidesPerView={5}
                    navigation
                    autoplay={{ delay: 2000, disableOnInteraction: false }}
                    breakpoints={breakpoints}
                  >
                    {products?.map((item, index) => (
                      <SwiperSlide>
                        <Card
                          isOnCart={isInCart(item._id) ? true : false}
                          key={item.name + index}
                          imgUrl={item?.images[0]?.url}
                          name={item.name}
                          price={item.weightPrice[0]?.price}
                          weight={item.weightPrice[0]?.weight}
                          salePrice={item.weightPrice[0]?.price}
                          category={item.category}
                          id={item._id}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* {---------------------CARD SECTION END----------------------------} */}

      {/* {---------------------BANNER SECTION START----------------------------} */}

      <div className="container about__banner">
        <div className="ab-left">
          <h3 className="ab-head-first">Why to choose us ?</h3>
          <h3 className="ab-head-sec">Why Free of Gluten?</h3>
          <p className="p-text">
            We are the first and the best Gluten-Free Café in South Delhi and the ultimate destination for gluten-free
            products throughout India. We take immense pride in our commitment to manufacture 100% gluten-free items to cater the needs of
            people with Gluten insensitivity or Celiac disease. We make careful measurements and adjustments to maintain right consistency
            and taste and pay proper attention
            to avoid cross contamination with gluten throughout the process of manufacturing. We understand the challenges faced by gluten-
            sensitive individuals and aim to provide them with
            delightful alternatives to their favorite dishes in unique flavours and textures, giving people a variety of choices
            which suits their tastebuds.
          </p>
          <span>
            <Link to="/shop" className="btn bl-btn">
              Go to Shop
            </Link>
            <Link to="/reach" className="btn bl-btn outline-btn">
              Reach Us
            </Link>
          </span>
        </div>

        <span className="ab-right">
          <img src={aboutBanner} alt="aboutbanner" />
        </span>
      </div>

      {/* {---------------------BANNER SECTION END----------------------------} */}

      {/* Yess section */}

      <div className="ysection">
        <div className="y-top">
          <h2 className="yess">Yesssssss!!!!!!</h2>
          <h1 className="its">It’s Healthy & Tasty</h1>
        </div>

        <div className="y-btm">
          <img src={bread} alt="bread" />
        </div>
      </div>

      {/* text section  */}
      <div className="lifestyle">
        <h1 className="lifestyle">
          <div>
            It's not just
            <span className="food"> Food,</span>
          </div>
          <div>
            It's a<span className="life"> Lifestyle!</span>
          </div>
        </h1>
      </div>

      {/* {---------------------TESTIMONIALS SECTION START----------------------------} */}
      <section className="test-wrapper">
        <div className=" container testimonials">
          <div className="test-text-wp">
            <div className="test-head">
              <h1>
                We Serve - they
                <span className="enjoy1"> Enjoy</span>
              </h1>
              <h1>
                Every minute of their
                <span className="live1"> Lives</span>
              </h1>
            </div>

            <p className="test-text">
              We passionately cater our customers with gluten sensitivities,
              allowing them to relish every moment without worry, while
              indulging in our mouthwatering and completely Gluten-Free
              products. Experience the joy of gluten-free living and embrace a
              life filled with flavorful delights.
            </p>
          </div>

          <div className="test-cards">
            <Swiper
              spaceBetween={20}
              slidesPerView={3}
              navigation // Enable navigation
              breakpoints={testBreakpoints}
              autoplay={{ delay: 2000, disableOnInteraction: false }}
            >
              <SwiperSlide>
                <TestimonialCard
                  name="Terri Place"
                  desc="Terrific and very broad gluten free selection! The staff were really helpful and friendly 
                  and went out of their way to help me with my first order. Will be trying more from their menu asap"
                />
              </SwiperSlide>

              <SwiperSlide>
                <TestimonialCard
                  name="Abhinav Gupta"
                  desc="Ordered a gluten free cake & I was so happily pleased 
              with everything. My go to place for gluten free food. Thanks for such amazing food."
                />
              </SwiperSlide>

              <SwiperSlide>
                <TestimonialCard
                  name="Vishal Bachani"
                  desc="The gluten free pineapple cake was the best !
                   Reminded me of the cake we used to get in our school days, with the quality maintained really well."
                />
              </SwiperSlide>

              <SwiperSlide>
                <TestimonialCard
                  name="Aditi Sharma"
                  desc="The cake was very yummy and loved by my kids..was delivered as per my requirement and the design
                   was perfect,just like my son wanted it to be..thanks alot CT for a super delicious gluten free eggless cake.."
                />
              </SwiperSlide>

              <SwiperSlide>
                <TestimonialCard
                  name="Mahima Seth"
                  desc="The best place to have gluten free food! Yummy & Delicious. My 
                  favourite is Pineapple Pastry. They have a gluten free dedicated kitchen which is a saviour for all the celiacs."
                />
              </SwiperSlide>

              <SwiperSlide>
                <TestimonialCard
                  name="Jatin Khurana"
                  desc="Gluten free Focaccia Bread and Brownie are just amazing. So Soft and Tasty... Kudos to the team"
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>

      {/* {---------------------TESTIMONIALS SECTION END----------------------------} */}
      <section className="cta">
        <div className="cta-wrapper container">
          <div className="cta-left">
            <h3 className="first">Join our community</h3>
            <h2 className="sec">YOU ARE NOT ALONE</h2>
            <p className="para">
              We invite you to be a part of our community FOGHEADS of Gluten
              sensitive individuals where your unique dietary needs are
              understood and celebrated. By joining our community you get access
              to valuable insights, resources and connections with the
              individuals with a shared sensitivity Together, let's embrace a
              gluten-free lifestyle and embark on a journey of shared
              inspiration and empowerment.
            </p>
          </div>
          <div className="cta-right">
            <form onSubmit={handleSubmit}>
              <div className="form-field">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* {---------------------SERVICE SECTION START----------------------------} */}

      <div className="service__detail">
        <div className="services__option">
          <div className="ser ser-1">
            <FiTruck />
            <h4>PAN India Delivery</h4>
            <p className="desc">on orders above ₹1999</p>
          </div>

          <div className="ser ser-1">
            <BiTimer />

            <h4>On Time Delivery</h4>
            <p className="desc">We won't be Late</p>
          </div>

          <div className="ser ser-2">
            <MdPayments />
            <h4>Secure Payments</h4>
            <p className="desc">100% Secure Gateway</p>
          </div>

          <div className="ser ser-3">
            <MdOutlineSupportAgent />
            <h4>24/7 Support</h4>
            <p className="desc">Our Team is working 24*7</p>
          </div>
        </div>
      </div>

      {/* {---------------------SERVICE SECTION END----------------------------} */}

    </div>
  );
}

export default Home;